<template>
  <router-view :wsmode=ws_mode :tmode=t_mode :mmode=m_mode />
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      screenWidth: window.innerWidth
    };
  },
  computed: {
    ws_mode() {
      return (this.screenWidth > 1270); 
    },
    t_mode() {
      return (this.screenWidth <= 1270 && this.screenWidth>773); 
    },
    m_mode() {
      return (this.screenWidth <= 773 ); 
    },
  },
  mounted() { //Cycle de vie du composant.
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Appel initial pour définir la largeur correcte
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    }
  }
}
</script>